import { render, staticRenderFns } from "./AddTeamDialog.vue?vue&type=template&id=c6825a1c"
import script from "./AddTeamDialog.vue?vue&type=script&lang=js"
export * from "./AddTeamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports